import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  i18nProfileStatusPipe,
  i18nRehireStatusPipe,
} from './i18n-convertor.pipe';

@NgModule({
  declarations: [i18nProfileStatusPipe, i18nRehireStatusPipe],
  imports: [CommonModule],
  exports: [i18nProfileStatusPipe, i18nRehireStatusPipe],
})
export class i18nPipeModule {}
